// AUTO-GENERATED by app-config-utils/generateFontsFile — do not edit by hand.
// Regenerated on each build/dev from the store's settings.layout.fonts.
import { Fraunces, DM_Sans, Grape_Nuts } from 'next/font/google'

const fraunces = Fraunces({
  subsets: ['latin', 'latin-ext'],
  weight: ['400', '500', '600', '700']
})

const dmSans = DM_Sans({
  subsets: ['latin', 'latin-ext'],
  weight: ['300', '400', '500', '600', '700']
})

const grapeNuts = Grape_Nuts({
  subsets: ['latin', 'latin-ext'],
  weight: ['400']
})

export const fonts = {
  heading: fraunces.style.fontFamily,
  body: dmSans.style.fontFamily,
  slogan: grapeNuts.style.fontFamily
}
